// src/pages/CreateDepositSuccessPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import { Box, TextField, Typography } from "@mui/material";
import { updateUserDeposit } from "../services/UserService";
import "./CreateDepositSuccessPage.css";
import PageHeader from "../components/PageHeader";

function CreateDepositSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Récupération des données du dépôt depuis le localStorage
  const depositData = JSON.parse(localStorage.getItem("depositData") || "{}");
  const { depositId, isOwnerNameProvided } = depositData;

  if (!depositId && !isOwnerNameProvided) {
    return <p>{t("createDepositSuccess.errorPrefix")} depositId is missing!</p>;
  }

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName) {
      setError(t("createDepositSuccess.errorPrefix") + " " + t("createDepositSuccess.enterName", "Please enter your first and last name."));
      return;
    }
    setError("");
    setLoading(true);
    try {
      await updateUserDeposit(depositId, firstName, lastName);
      setSuccessMessage(t("createDepositSuccess.success"));
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (err) {
      setError(t("createDepositSuccess.errorPrefix") + " " + err.message);
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader
        title={t("createDepositSuccess.title")}
        subtitle={`${t("createDepositSuccess.referenceLabel")} ${depositId}`}
      />

      {!isOwnerNameProvided && (
        <Card title={t("createDepositSuccess.cardTitle")}>
          <Box component="form" onSubmit={handleUpdate}>
            <p className="prompt">
              {t("createDepositSuccess.prompt")}
            </p>
            <TextField
              label={t("createDepositSuccess.firstNameLabel")}
              variant="outlined"
              fullWidth
              margin="normal"
              value={firstName}
              disabled={loading}
              onChange={(e) => setFirstName(e.target.value)}
              required
              className="rounded-textfield"
            />
            <TextField
              label={t("createDepositSuccess.lastNameLabel")}
              variant="outlined"
              fullWidth
              margin="normal"
              value={lastName}
              disabled={loading}
              onChange={(e) => setLastName(e.target.value)}
              required
              className="rounded-textfield bottom-margin"
            />
            <Button
              label={loading ? t("createDepositSuccess.loading") : t("createDepositSuccess.updateButton")}
              onClick={handleUpdate}
              disabled={loading}
              type="submit"
            />
            {error && (
              <p className="error-message">
                {error}
              </p>
            )}
            {successMessage && (
              <p className="success-message">
                {successMessage}
              </p>
            )}
          </Box>
        </Card>
      )}
    </Layout>
  );
}

export default CreateDepositSuccessPage;
